import { useState } from 'react';

const testimonials = [
  {
    quote:
      'GTBuy Spreadsheet completely transformed how I manage my sourcing operations. The automation features saved me hours every week, and the comparison tools helped me make the right choice for my workflow.',
    name: 'Marcus Chen',
    role: 'E-commerce Sourcing Agent',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20a%20man%20in%20his%20early%20thirties%20with%20confident%20expression%2C%20clean%20cream%20background%2C%20soft%20natural%20studio%20lighting%2C%20warm%20neutral%20tones%2C%20modern%20corporate%20portrait%20style%2C%20minimal%20composition&width=120&height=120&seq=avatar-marcus-01&orientation=squarish',
  },
  {
    quote:
      'I compared three different spreadsheet tools before choosing GTBuy. The side-by-side breakdown on this site made the decision incredibly easy. Highly recommend for anyone in the buying agent space.',
    name: 'Sarah Williams',
    role: 'Product Sourcing Manager',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20a%20woman%20in%20her%20late%20twenties%20with%20friendly%20smile%2C%20clean%20warm%20beige%20background%2C%20soft%20natural%20studio%20lighting%2C%20warm%20neutral%20color%20tones%2C%20modern%20corporate%20portrait%20style%2C%20minimal%20professional%20composition&width=120&height=120&seq=avatar-sarah-02&orientation=squarish',
  },
  {
    quote:
      'The workflow automation insights on GTBuy Spreadsheet are unmatched. We reduced our manual tracking errors by over 80% after switching. This comparison site is a goldmine for sourcing professionals.',
    name: 'David Park',
    role: 'Supply Chain Coordinator',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20a%20man%20in%20his%20mid%20thirties%20with%20calm%20confident%20expression%2C%20clean%20cream%20white%20background%2C%20soft%20natural%20studio%20lighting%2C%20warm%20neutral%20tones%2C%20modern%20corporate%20portrait%20style%2C%20minimal%20composition&width=120&height=120&seq=avatar-david-03&orientation=squarish',
  },
];

export default function TrustSection() {
  const [currentIndex, setCurrentIndex] = useState(0);

  const prev = () => {
    setCurrentIndex((prev) => (prev === 0 ? testimonials.length - 1 : prev - 1));
  };

  const next = () => {
    setCurrentIndex((prev) => (prev === testimonials.length - 1 ? 0 : prev + 1));
  };

  const current = testimonials[currentIndex];

  return (
    <section className="bg-background-50 py-16 md:py-20">
      <div className="w-full px-4 md:px-6 max-w-3xl mx-auto text-center">
        <h2 className="font-heading text-2xl md:text-3xl text-foreground-700 italic mb-10">
          ( Trusted by Real Users )
        </h2>

        <div className="relative">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-primary-500 mb-8">
            <i className="ri-star-fill text-accent-500 text-sm"></i>
            <span className="text-background-50 text-sm font-semibold">4.9/5.0</span>
          </div>

          <blockquote className="mb-8">
            <p className="font-heading text-lg md:text-xl text-foreground-800 leading-relaxed italic">
              &ldquo;{current.quote}&rdquo;
            </p>
          </blockquote>

          <div className="flex items-center justify-center gap-3 mb-10">
            <img
              src={current.avatar}
              alt={current.name}
              className="w-12 h-12 rounded-full object-cover"
            />
            <div className="text-left">
              <p className="text-sm font-semibold text-foreground-950">{current.name}</p>
              <p className="text-xs text-foreground-500">{current.role}</p>
            </div>
          </div>

          <div className="flex items-center justify-center gap-3">
            <button
              onClick={prev}
              className="w-10 h-10 rounded-full bg-background-100 border border-background-200 flex items-center justify-center text-foreground-600 hover:bg-background-200 hover:text-foreground-950 transition-all duration-200 cursor-pointer"
            >
              <i className="ri-arrow-left-line"></i>
            </button>
            <button
              onClick={next}
              className="w-10 h-10 rounded-full bg-primary-500 flex items-center justify-center text-background-50 hover:bg-primary-600 transition-all duration-200 cursor-pointer"
            >
              <i className="ri-arrow-right-line"></i>
            </button>
          </div>

          <div className="flex items-center justify-center gap-1.5 mt-6">
            {testimonials.map((_, idx) => (
              <button
                key={idx}
                onClick={() => setCurrentIndex(idx)}
                className={`w-2 h-2 rounded-full transition-all duration-300 cursor-pointer ${
                  idx === currentIndex ? 'bg-primary-500 w-5' : 'bg-background-300'
                }`}
              ></button>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}